

import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login.vue"),
    meta: {
      title: "登录",
      quick: false,
    },
  },
  {
    path: "/findpwd",
    name: "findpwd",
    component: () => import("@/views/FindPassword.vue"),
    meta: {
      title: "找回密码",
      quick: false,
    },
  },
  {
    path: "/bigScreen",
    name: "bigScreen",
    component: () => import("@/views/BigScreen.vue"),
    meta: {
      title: "大屏数据",
      quick: false,
    },
  },
  {
    path: "/agreement",
    name: "agreement",
    component: () => import("@/views/agreement.vue"),
    meta: {
      title: "用户协议",
      quick: false,
    },
  },
  //销售合同
  {
    path: "/bargain",
    name: "bargain",
    component: () => import("@/views/bargain.vue"),
    meta: {
      title: "用户协议",
      quick: false,
    },
  },
  {
    path: "/",
    name: "main",
    component: () => import("../views/Main.vue"),
    redirect: { name: "home" },
    children: [
      //首页
      {
        path: "/home",
        name: "home",
        component: () => import("../views/Home.vue"),
      },
      /*************** #start 系统权限管理 *********************/
      {
        path: "/zzmenu",
        name: "zzmenu",
        component: () => import("@/views/ZzMenu.vue"),
        meta: {
          title: "菜单配置",
          quick: false,
        },
      },
      {
        path: "/zzrole",
        name: "zzrole",
        component: () => import("@/views/ZzRole.vue"),
        meta: {
          title: "角色配置",
          quick: false,
        },
      },
      /*************** #end 系统权限管理 *********************/
      /*************** #start 基础中心 *********************/
      // 权限管理
      {
        path: "/base-center/permission-manage/role/list",
        name: "base-center-base-center-permission-manage-role-list",
        component: () => import("../views/base-center/permission-manage/role/List.vue"),
      },
      {
        path: "/base-center/permission-manage/role/add",
        name: "base-center-base-center-permission-manage-role-add",
        component: () => import("../views/base-center/permission-manage/role/Add.vue"),
      },
      {
        path: "/base-center/permission-manage/role/edit",
        name: "base-center-base-center-permission-manage-role-edit",
        component: () => import("../views/base-center/permission-manage/role/Add.vue"),
      },
      {
        path: "/base-center/permission-manage/user/list",
        name: "base-center-base-center-permission-manage-user-list",
        component: () => import("../views/base-center/permission-manage/user/List.vue"),
      },
      {
        path: "/base-center/permission-manage/user/add",
        name: "base-center-base-center-permission-manage-user-add",
        component: () => import("../views/base-center/permission-manage/user/Add.vue"),
      },
      {
        path: "/base-center/permission-manage/user/edit",
        name: "base-center-base-center-permission-manage-user-edit",
        component: () => import("../views/base-center/permission-manage/user/Add.vue"),
      },
      {
        path: "/base-center/permission-manage/user/view",
        name: "base-center-base-center-permission-manage-user-view",
        component: () => import("../views/base-center/permission-manage/user/View.vue"),
      },
      // 基础商品
      {
        path: "/base-center/base-goods/nation/list",
        name: "base-center-base-goods-nation-list",
        component: () => import("../views/base-center/base-goods/nation/List.vue"),
      },
      {
        path: "/base-center/base-goods/nation/add",
        name: "base-center-base-goods-nation-add",
        component: () => import("../views/base-center/base-goods/nation/Add.vue"),
      },
      {
        path: "/base-center/base-goods/nation/edit",
        name: "base-center-base-goods-nation-edit",
        component: () => import("../views/base-center/base-goods/nation/Add.vue"),
      },
      {
        path: "/base-center/base-goods/brand/list",
        name: "base-center-base-goods-brand-list",
        component: () => import("../views/base-center/base-goods/brand/List.vue"),
      },
      {
        path: "/base-center/base-goods/brand/add",
        name: "base-center-base-goods-brand-add",
        component: () => import("../views/base-center/base-goods/brand/Add.vue"),
      },
      {
        path: "/base-center/base-goods/brand/edit",
        name: "base-center-base-goods-brand-edit",
        component: () => import("../views/base-center/base-goods/brand/Add.vue"),
      },
      {
        path: "/base-center/base-goods/label/list",
        name: "base-center-base-goods-label-list",
        component: () => import("../views/base-center/base-goods/label/List.vue"),
      },
      {
        path: "/base-center/base-goods/label/add",
        name: "base-center-base-goods-label-add",
        component: () => import("../views/base-center/base-goods/label/Add.vue"),
      },
      {
        path: "/base-center/base-goods/label/edit",
        name: "base-center-base-goods-label-edit",
        component: () => import("../views/base-center/base-goods/label/Add.vue"),
      },
      {
        path: "/base-center/base-goods/category/list",
        name: "base-center-base-goods-category-list",
        component: () => import("../views/base-center/base-goods/category/List.vue"),
      },
      {
        path: "/base-center/base-goods/attribute/list",
        name: "base-center-base-goods-attribute-list",
        component: () => import("../views/base-center/base-goods/attribute/List.vue"),
      },
      {
        path: "/base-center/base-goods/attribute/add",
        name: "base-center-base-goods-attribute-add",
        component: () => import("../views/base-center/base-goods/attribute/Add.vue"),
      },
      {
        path: "/base-center/base-goods/attribute/edit",
        name: "base-center-base-goods-attribute-edit",
        component: () => import("../views/base-center/base-goods/attribute/Add.vue"),
      },
      {
        path: "/base-center/base-goods/spu/list",
        name: "base-center-base-goods-spu-list",
        component: () => import("../views/base-center/base-goods/spu/List.vue"),
      },
      {
        path: "/base-center/base-goods/spu/add",
        name: "base-center-base-goods-spu-add",
        component: () => import("../views/base-center/base-goods/spu/Add.vue"),
      },
      {
        path: "/base-center/base-goods/spu/edit",
        name: "base-center-base-goods-spu-edit",
        component: () => import("../views/base-center/base-goods/spu/Add.vue"),
      },
      {
        path: "/base-center/base-goods/sku/list",
        name: "base-center-base-goods-sku-list",
        component: () => import("../views/base-center/base-goods/sku/List.vue"),
      },
      {
        path: "/base-center/base-goods/sku/add",
        name: "base-center-base-goods-sku-add",
        component: () => import("../views/base-center/base-goods/sku/Add.vue"),
      },
      {
        path: "/base-center/base-goods/sku/edit",
        name: "/base-center/base-goods/sku/edit",
        component: () => import("../views/base-center/base-goods/sku/Add.vue"),
      },
      {
        path: "/base-center/base-goods/sku/view",
        name: "base-center-base-goods-sku-view",
        component: () => import("../views/base-center/base-goods/sku/View.vue"),
      },
      {
        path: "/base-center/base-goods/batch/list",
        name: "base-center-base-goods-batch-list",
        component: () => import("../views/base-center/base-goods/batch/List.vue"),
      },
      {
        path: "/base-center/base-goods/batch/view",
        name: "base-center-base-goods-batch-view",
        component: () => import("../views/base-center/base-goods/batch/View.vue"),
      },
      {
        path: "/base-center/base-goods/evaluation/list",
        name: "base-center-base-goods-evaluation-list",
        component: () => import("../views/base-center/base-goods/evaluation/List.vue"),
      },
      {
        path: "/base-center/base-goods/evaluation/list",
        name: "base-center-base-goods-evaluation-list",
        component: () => import("../views/base-center/base-goods/evaluation/List.vue"),
      },
      //产品线
      {
        path: "/base-center/base-goods/product/list",
        name: "base-center-base-goods-product-list",
        component: () => import("../views/base-center/base-goods/product/List.vue"),
      },
      {
        path: "/base-center/base-goods/product/view",
        name: "base-center-base-goods-product-view",
        component: () => import("../views/base-center/base-goods/product/View.vue"),
      },
      // 库位运费
      {
        path: "/base-center/warhouse-freight/warhouse/list",
        name: "base-center-warhouse-freight-warhouse-list",
        component: () => import("../views/base-center/warhouse-freight/warhouse/List.vue"),
      },
      {
        path: "/base-center/warhouse-freight/warhouse/add",
        name: "base-center-warhouse-freight-warhouse-add",
        component: () => import("../views/base-center/warhouse-freight/warhouse/Add.vue"),
      },
      {
        path: "/base-center/warhouse-freight/warhouse/edit",
        name: "base-center-warhouse-freight-warhouse-edit",
        component: () => import("../views/base-center/warhouse-freight/warhouse/Add.vue"),
      },
      {
        path: "/base-center/warhouse-freight/freight/list",
        name: "base-center-warhouse-freight-freight-list",
        component: () => import("../views/base-center/warhouse-freight/freight/List.vue"),
      },
      {
        path: "/base-center/warhouse-freight/freight/add",
        name: "base-center-warhouse-freight-freight-add",
        component: () => import("../views/base-center/warhouse-freight/freight/Add.vue"),
      },
      {
        path: "/base-center/warhouse-freight/freight/edit",
        name: "base-center-warhouse-freight-freight-edit",
        component: () => import("../views/base-center/warhouse-freight/freight/Add.vue"),
      },

      //   用户管理
      {
        path: "/base-center/user-manage/chain-manage/list",
        name: "base-center-user-manage-chain-manage-list",
        component: () => import("../views/base-center/user-manage/chain-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/chain-manage/add",
        name: "base-center-user-manage-chain-manage-add",
        component: () => import("../views/base-center/user-manage/chain-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/chain-manage/edit",
        name: "base-center-user-manage-chain-manage-edit",
        component: () => import("../views/base-center/user-manage/chain-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/chain-manage/view",
        name: "base-center-user-manage-chain-manage-view",
        component: () => import("../views/base-center/user-manage/chain-manage/View.vue"),
      },
      //销售代表
      {
        path: "/base-center/user-manage/sale-represent/list",
        name: "base-center-user-manage-sale-represent-list",
        component: () => import("../views/base-center/user-manage/sale-represent/List.vue"),
      },
      {
        path: "/base-center/user-manage/sale-represent/add",
        name: "base-center-user-manage-sale-represent-add",
        component: () => import("../views/base-center/user-manage/sale-represent/Add.vue"),
      },
      {
        path: "/base-center/user-manage/sale-represent/edit",
        name: "base-center-user-manage-sale-represent-edit",
        component: () => import("../views/base-center/user-manage/sale-represent/Add.vue"),
      },
      {
        path: "/base-center/user-manage/sale-represent/view",
        name: "base-center-user-manage-sale-represent-view",
        component: () => import("../views/base-center/user-manage/sale-represent/View.vue"),
      },
      //   门店等级
      {
        path: "/base-center/user-manage/shop-level/list",
        name: "base-center-user-manage-shop-level-list",
        component: () => import("../views/base-center/user-manage/shop-level/List.vue"),
      },
      {
        path: "/base-center/user-manage/shop-level/add",
        name: "base-center-user-manage-shop-level-add",
        component: () => import("../views/base-center/user-manage/shop-level/Add.vue"),
      },
      {
        path: "/base-center/user-manage/shop-level/edit",
        name: "base-center-user-manage-shop-level-edit",
        component: () => import("../views/base-center/user-manage/shop-level/Add.vue"),
      },
      {
        path: "/base-center/user-manage/shop-level/view",
        name: "base-center-user-manage-shop-level-view",
        component: () => import("../views/base-center/user-manage/shop-level/View.vue"),
      },
      //邀请码
      {
        path: "/base-center/user-manage/invitation-code/list",
        name: "base-center-user-manage-invitation-code-list",
        component: () => import("../views/base-center/user-manage/invitation-code/List.vue"),
      },
      {
        path: "/base-center/user-manage/invitation-code/add",
        name: "base-center-user-manage-invitation-code-add",
        component: () => import("../views/base-center/user-manage/invitation-code/Add.vue"),
      },
      {
        path: "/base-center/user-manage/invitation-code/edit",
        name: "base-center-user-manage-invitation-code-edit",
        component: () => import("../views/base-center/user-manage/invitation-code/Add.vue"),
      },
      {
        path: "/base-center/user-manage/invitation-code/view",
        name: "base-center-user-manage-invitation-code-view",
        component: () => import("../views/base-center/user-manage/invitation-code/View.vue"),
      },
      //门店管理
      {
        path: "/base-center/user-manage/shop-manage/list",
        name: "base-center-user-manage-shop-manage-list",
        component: () => import("../views/base-center/user-manage/shop-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/shop-manage/add",
        name: "base-center-user-manage-shop-manage-add",
        component: () => import("../views/base-center/user-manage/shop-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/shop-manage/edit",
        name: "base-center-user-manage-shop-manage-edit",
        component: () => import("../views/base-center/user-manage/shop-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/shop-manage/view",
        name: "base-center-user-manage-shop-manage-view",
        component: () => import("../views/base-center/user-manage/shop-manage/View.vue"),
      },
      //发票管理
      {
        path: "/base-center/user-manage/invoice-manage/list",
        name: "base-center-user-manage-invoice-manage-list",
        component: () => import("../views/base-center/user-manage/invoice-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/invoice-manage/add",
        name: "base-center-user-manage-invoice-manage-add",
        component: () => import("../views/base-center/user-manage/invoice-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/invoice-manage/edit",
        name: "base-center-user-manage-invoice-manage-edit",
        component: () => import("../views/base-center/user-manage/invoice-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/invoice-manage/view",
        name: "base-center-user-manage-invoice-manage-view",
        component: () => import("../views/base-center/user-manage/invoice-manage/View.vue"),
      },
      //店员管理
      {
        path: "/base-center/user-manage/staff-manage/list",
        name: "base-center-user-manage-staff-manage-list",
        component: () => import("../views/base-center/user-manage/staff-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/staff-manage/add",
        name: "base-center-user-manage-staff-manage-add",
        component: () => import("../views/base-center/user-manage/staff-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/staff-manage/edit",
        name: "base-center-user-manage-staff-manage-edit",
        component: () => import("../views/base-center/user-manage/staff-manage/Add.vue"),
      },
      {
        path: "/base-center/user-manage/staff-manage/view",
        name: "base-center-user-manage-staff-manage-view",
        component: () => import("../views/base-center/user-manage/staff-manage/View.vue"),
      },
      //会员列表
      {
        path: "/base-center/user-manage/member-manage/list",
        name: "base-center-user-manage-member-manage-list",
        component: () => import("../views/base-center/user-manage/member-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/member-manage/view",
        name: "base-center-user-manage-member-manage-view",
        component: () => import("../views/base-center/user-manage/member-manage/View.vue"),
      },
      //区域列表
      {
        path: "/base-center/user-manage/area-manage/list",
        name: "base-center-user-manage-area-manage-list",
        component: () => import("../views/base-center/user-manage/area-manage/List.vue"),
      },
      {
        path: "/base-center/user-manage/area-manage/view",
        name: "base-center-user-manage-area-manage-view",
        component: () => import("../views/base-center/user-manage/area-manage/View.vue"),
      },
      //   系统配置
      {
        path: "/base-center/system-configuration/download/list",
        name: "base-center-system-configuration-download-list",
        component: () => import("../views/base-center/system-configuration/download/List.vue"),
      },
      {
        path: "/base-center/system-configuration/commission-rule/list",
        name: "base-center-system-configuration-commission-rule-list",
        component: () => import("../views/base-center/system-configuration/commission-rule/List.vue"),
      },
      {
        path: "/base-center/system-configuration/commission-rule/add",
        name: "base-center-system-configuration-commission-rule-add",
        component: () => import("../views/base-center/system-configuration/commission-rule/Add.vue"),
      },
      {
        path: "/base-center/system-configuration/commission-rule/edit",
        name: "base-center-system-configuration-commission-rule-edit",
        component: () => import("../views/base-center/system-configuration/commission-rule/Add.vue"),
      },
      {
        path: "/base-center/system-configuration/commission-rule/view",
        name: "base-center-system-configuration-commission-rule-view",
        component: () => import("../views/base-center/system-configuration/commission-rule/View.vue"),
      },
      {
        path: "/base-center/system-configuration/system-rule/list",
        name: "base-center-system-configuration-system-rule-list",
        component: () => import("../views/base-center/system-configuration/system-rule/List.vue"),
      },
      //平台协议
      {
        path: "/base-center/system-configuration/platform-agreement/list",
        name: "base-center-system-configuration-platform-agreement-list",
        component: () => import("../views/base-center/system-configuration/platform-agreement/List.vue"),
      },
      {
        path: "/base-center/system-configuration/platform-agreement/edit",
        name: "base-center-system-configuration-platform-agreement-edit",
        component: () => import("../views/base-center/system-configuration/platform-agreement/Add.vue"),
      },
      //app版本管理
      {
        path: "/base-center/system-configuration/APP-version/list",
        name: "base-center-system-configuration-APP-version-list",
        component: () => import("../views/base-center/system-configuration/APP-version/List.vue"),
      },
      {
        path: "/base-center/system-configuration/APP-version/add",
        name: "base-center-system-configuration-APP-version-add",
        component: () => import("../views/base-center/system-configuration/APP-version/Add.vue"),
      },
      //扫码激励
      {
        path: "/base-center/system-configuration/scancode-incentive/list",
        name: "base-center-system-configuration-scancode-incentive-list",
        component: () => import("../views/base-center/system-configuration/scancode-incentive/List.vue"),
      },
      {
        path: "/base-center/system-configuration/scancode-incentive/add",
        name: "base-center/system-configuration/scancode-incentive-add",
        component: () => import("../views/base-center/system-configuration/scancode-incentive/Add.vue"),
      },
      {
        path: "/base-center/system-configuration/scancode-incentive/edit",
        name: "base-center/system-configuration/scancode-incentive-edit",
        component: () => import("../views/base-center/system-configuration/scancode-incentive/Add.vue"),
      },
      {
        path: "/base-center/system-configuration/scancode-incentive/view",
        name: "base-center/system-configuration/scancode-incentive-view",
        component: () => import("../views/base-center/system-configuration/scancode-incentive/View.vue"),
      },
      //驾驶舱
      {
        path: "/base-center/system-configuration/cockpit/list",
        name: "base-center-system-configuration-cockpit-list",
        component: () => import("../views/base-center/system-configuration/cockpit/List.vue"),
      },
      {
        path: "/base-center/system-configuration/cockpit/edit",
        name: "base-center/system-configuration/cockpit-edit",
        component: () => import("../views/base-center/system-configuration/cockpit/Add.vue"),
      },
      {
        path: "/base-center/system-configuration/cockpit/view",
        name: "base-center/system-configuration/cockpit-view",
        component: () => import("../views/base-center/system-configuration/cockpit/View.vue"),
      },
      /*************** #end 基础中心 *********************/
      /*************** #start 零售中心 *********************/
      //   商品管理
      {
        path: "/retail-center/goods-manage/retail-goods/list",
        name: "retail-center-goods-manage-retail-goods-list",
        component: () => import("../views/retail-center/goods-manage/retail-goods/List.vue"),
      },
      {
        path: "/retail-center/goods-manage/retail-goods/add",
        name: "retail-center-goods-manage-retail-goods-add",
        component: () => import("../views/retail-center/goods-manage/retail-goods/Add.vue"),
      },
      {
        path: "/retail-center/goods-manage/retail-goods/edit",
        name: "retail-center-goods-manage-retail-goods-edit",
        component: () => import("../views/retail-center/goods-manage/retail-goods/Add.vue"),
      },
      {
        path: "/retail-center/goods-manage/retail-goods/view",
        name: "retail-center-goods-manage-retail-goods-view",
        component: () => import("../views/retail-center/goods-manage/retail-goods/View.vue"),
      },
      //   备案信息
      {
        path: "/retail-center/goods-manage/record-info/list",
        name: "retail-center-goods-manage-record-info-list",
        component: () => import("../views/retail-center/goods-manage/record-info/List.vue"),
      },
      {
        path: "/retail-center/goods-manage/record-info/add",
        name: "retail-center-goods-manage-record-info-add",
        component: () => import("../views/retail-center/goods-manage/record-info/Add.vue"),
      },
      {
        path: "/retail-center/goods-manage/record-info/edit",
        name: "retail-center-goods-manage-record-info-edit",
        component: () => import("../views/retail-center/goods-manage/record-info/Add.vue"),
      },
      {
        path: "/retail-center/goods-manage/record-info/view",
        name: "retail-center-goods-manage-record-info-view",
        component: () => import("../views/retail-center/goods-manage/record-info/View.vue"),
      },
      //   库存配额
      {
        path: "/retail-center/stock-quota/stock/list",
        name: "retail-center-stock-quota-stock-list",
        component: () => import("../views/retail-center/stock-quota/stock/List.vue"),
      },
      {
        path: "/retail-center/stock-quota/stock/add",
        name: "retail-center-stock-quota-stock-add",
        component: () => import("../views/retail-center/stock-quota/stock/Add.vue"),
      },
      {
        path: "/retail-center/stock-quota/stock/edit",
        name: "retail-center-stock-quota-stock-edit",
        component: () => import("../views/retail-center/stock-quota/stock/Add.vue"),
      },
      {
        path: "/retail-center/stock-quota/stock/view",
        name: "retail-center-stock-quota-stock-view",
        component: () => import("../views/retail-center/stock-quota/stock/View.vue"),
      },
      {
        path: "/retail-center/stock-quota/quota/list",
        name: "retail-center-stock-quota-quota-list",
        component: () => import("../views/retail-center/stock-quota/quota/List.vue"),
      },
      {
        path: "/retail-center/stock-quota/quota/add",
        name: "retail-center-stock-quota-quota-add",
        component: () => import("../views/retail-center/stock-quota/quota/Add.vue"),
      },
      {
        path: "/retail-center/stock-quota/quota/edit",
        name: "retail-center-stock-quota-quota-edit",
        component: () => import("../views/retail-center/stock-quota/quota/Add.vue"),
      },
      {
        path: "/retail-center/stock-quota/quota/view",
        name: "retail-center-stock-quota-quota-view",
        component: () => import("../views/retail-center/stock-quota/quota/View.vue"),
      },

      //   交易管理
      //订单规则
      {
        path: "/retail-center/transaction-management/order-rule/list",
        name: "retail-center-transaction-management-order-rule-list",
        component: () => import("../views/retail-center/transaction-management/order-rule/List.vue"),
      },
      {
        path: "/retail-center/transaction-management/order-rule/add-channel",
        name: "retail-center-transaction-management-order-rule-add-channel",
        component: () => import("../views/retail-center/transaction-management/order-rule/AddChannel.vue"),
      },
      {
        path: "/retail-center/transaction-management/order-rule/edit-channel",
        name: "retail-center-transaction-management-order-rule-edit-channel",
        component: () => import("../views/retail-center/transaction-management/order-rule/AddChannel.vue"),
      },
      {
        path: "/retail-center/transaction-management/order-rule/View-channel",
        name: "retail-center-transaction-management-order-rule-View-channel",
        component: () => import("../views/retail-center/transaction-management/order-rule/ViewChannel.vue"),
      },

      {
        path: "/retail-center/transaction-management/order-rule/add",
        name: "retail-center-transaction-management-order-rule-add",
        component: () => import("../views/retail-center/transaction-management/order-rule/Add.vue"),
      },
      {
        path: "/retail-center/transaction-management/order-rule/edit",
        name: "retail-center-transaction-management-order-rule-edit",
        component: () => import("../views/retail-center/transaction-management/order-rule/Add.vue"),
      },

      {
        path: "/retail-center/transaction-management/order-rule/view",
        name: "retail-center-transaction-management-order-rule-view",
        component: () => import("../views/retail-center/transaction-management/order-rule/View.vue"),
      },
      //赠品订单
      {
        path: "/retail-center/transaction-management/gift/list",
        name: "retail-center-transaction-management-gift-list",
        component: () => import("../views/retail-center/transaction-management/gift/List.vue"),
      },

      {
        path: "/retail-center/transaction-management/gift/view",
        name: "retail-center-transaction-management-gift-view",
        component: () => import("../views/retail-center/transaction-management/gift/View.vue"),
      },

      //零售订单
      {
        path: "/retail-center/transaction-management/order/list",
        name: "retail-center-transaction-management-order-list",
        component: () => import("../views/retail-center/transaction-management/order/List.vue"),
      },

      {
        path: "/retail-center/transaction-management/order/view",
        name: "retail-center-transaction-management-order-view",
        component: () => import("../views/retail-center/transaction-management/order/View.vue"),
      },

      //零售退单
      {
        path: "/retail-center/transaction-management/chargebacks/add",
        name: "retail-center-transaction-management-chargebacks-add",
        component: () => import("../views/retail-center/transaction-management/chargebacks/Add.vue"),
      },
      {
        path: "/retail-center/transaction-management/chargebacks/list",
        name: "retail-center-transaction-management-chargebacks-list",
        component: () => import("../views/retail-center/transaction-management/chargebacks/List.vue"),
      },

      {
        path: "/retail-center/transaction-management/chargebacks/view",
        name: "retail-center-transaction-management-chargebacks-view",
        component: () => import("../views/retail-center/transaction-management/chargebacks/View.vue"),
      },

      /*************** #end 零售中心 *********************/
      /*************** #start 分销中心 *********************/
      // 商品管理
      {
        path: "/distribution-center/goods-manage/distribution-goods/list",
        name: "distribution-center-goods-manage-distribution-goods-list",
        component: () => import("../views/distribution-center/goods-manage/distribution-goods/List.vue"),
      },
      {
        path: "/distribution-center/goods-manage/distribution-goods/add",
        name: "distribution-center-goods-manage-distribution-goods-add",
        component: () => import("../views/distribution-center/goods-manage/distribution-goods/Add.vue"),
      },
      {
        path: "/distribution-center/goods-manage/distribution-goods/edit",
        name: "distribution-center-goods-manage-distribution-goods-edit",
        component: () => import("../views/distribution-center/goods-manage/distribution-goods/Add.vue"),
      },
      {
        path: "/distribution-center/goods-manage/distribution-goods/view",
        name: "distribution-center-goods-manage-distribution-goods-view",
        component: () => import("../views/distribution-center/goods-manage/distribution-goods/View.vue"),
      },

      //库存配额
      {
        path: "/distribution-center/stock-quota/stock/list",
        name: "distribution-center-stock-quota-stock-list",
        component: () => import("../views/distribution-center/stock-quota/stock/List.vue"),
      },
      {
        path: "/distribution-center/stock-quota/stock/add",
        name: "distribution-center-stock-quota-stock-add",
        component: () => import("../views/distribution-center/stock-quota/stock/Add.vue"),
      },
      {
        path: "/distribution-center/stock-quota/stock/edit",
        name: "distribution-center-stock-quota-stock-edit",
        component: () => import("../views/distribution-center/stock-quota/stock/Add.vue"),
      },
      {
        path: "/distribution-center/stock-quota/stock/view",
        name: "distribution-center-stock-quota-stock-view",
        component: () => import("../views/distribution-center/stock-quota/stock/View.vue"),
      },
      {
        path: "/distribution-center/stock-quota/quota/list",
        name: "distribution-center-stock-quota-quota-list",
        component: () => import("../views/distribution-center/stock-quota/quota/List.vue"),
      },
      {
        path: "/distribution-center/stock-quota/quota/add",
        name: "distribution-center-stock-quota-quota-add",
        component: () => import("../views/distribution-center/stock-quota/quota/Add.vue"),
      },
      {
        path: "/distribution-center/stock-quota/quota/edit",
        name: "distribution-center-stock-quota-quota-edit",
        component: () => import("../views/distribution-center/stock-quota/quota/Add.vue"),
      },
      {
        path: "/distribution-center/stock-quota/quota/view",
        name: "distribution-center-stock-quota-quota-view",
        component: () => import("../views/distribution-center/stock-quota/quota/View.vue"),
      },

      // 交易管理
      //支付配置
      {
        path: "/distribution-center/transaction-management/pay/list",
        name: "distribution-center-transaction-management-pay-list",
        component: () => import("../views/distribution-center/transaction-management/pay/List.vue"),
      },

      //异常订单
      {
        path: "/distribution-center/transaction-management/error-order/list",
        name: "distribution-center-transaction-management-error-order-list",
        component: () => import("../views/distribution-center/transaction-management/error-order/List.vue"),
      },

      //分销订单
      {
        path: "/distribution-center/transaction-management/order/list",
        name: "distribution-center-transaction-management-order-list",
        component: () => import("../views/distribution-center/transaction-management/order/List.vue"),
      },

      {
        path: "/distribution-center/transaction-management/order/view",
        name: "distribution-center-transaction-management-order-view",
        component: () => import("../views/distribution-center/transaction-management/order/View.vue"),
      },

      //分销退单
      {
        path: "/distribution-center/transaction-management/chargebacks/add",
        name: "distribution-center-transaction-management-chargebacks-add",
        component: () => import("../views/distribution-center/transaction-management/chargebacks/Add.vue"),
      },
      {
        path: "/distribution-center/transaction-management/chargebacks/list",
        name: "distribution-center-transaction-management-chargebacks-list",
        component: () => import("../views/distribution-center/transaction-management/chargebacks/List.vue"),
      },

      {
        path: "/distribution-center/transaction-management/chargebacks/view",
        name: "distribution-center-transaction-management-chargebacks-view",
        component: () => import("../views/distribution-center/transaction-management/chargebacks/View.vue"),
      },
      //分销运营-返利导入
      {
        path: "/distribution-center/distribution-operations/rebate-import/list",
        name: "distribution-center-distribution-operations-rebate-import-list",
        component: () => import("../views/distribution-center/distribution-operations/rebate-import/List.vue"),
      },
      //返利查看
      {
        path: "/distribution-center/distribution-operations/rebate-view/list",
        name: "distribution-center-distribution-operations-rebate-view-list",
        component: () => import("../views/distribution-center/distribution-operations/rebate-view/List.vue"),
      },
      //返利报表
      {
        path: "/distribution-center/distribution-operations/rebate-report/list",
        name: "distribution-center-distribution-operations-rebate-report-list",
        component: () => import("../views/distribution-center/distribution-operations/rebate-report/List.vue"),
      },
      /*************** #end 分销中心 *********************/
      /*************** #start 运营中心 *********************/
      // B端促销活动 - 陈列PK赛
      {
        path: "/operate-center/toB-activity/store-pk-competition/list",
        name: "operate-center-toB-activity-store-pk-competition-list",
        component: () => import("../views/operate-center/toB-activity/store-pk-competition/List.vue"),
      },
      {
        path: "/operate-center/toB-activity/store-pk-competition/add",
        name: "operate-center-toB-activity-store-pk-competition-add",
        component: () => import("../views/operate-center/toB-activity/store-pk-competition/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/store-pk-competition/edit",
        name: "operate-center-toB-activity-store-pk-competition-edit",
        component: () => import("../views/operate-center/toB-activity/store-pk-competition/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/store-pk-competition/view",
        name: "operate-center-toB-activity-store-pk-competition-view",
        component: () => import("../views/operate-center/toB-activity/store-pk-competition/View.vue"),
      },
      //   陈列pk赛报名- 详情
      {
        path: "/operate-center/toB-activity/store-pk-competition/sign-up-view",
        name: "operate-center-toB-activity-store-pk-competition-sign-up-view",
        component: () => import("../views/operate-center/toB-activity/store-pk-competition/SignUpView.vue"),
      },

      // B端促销活动 - 组合活动
      {
        path: "/operate-center/toB-activity/combine-activity/list",
        name: "operate-center-toB-activity-combine-activity-list",
        component: () => import("../views/operate-center/toB-activity/combine-activity/List.vue"),
      },
      {
        path: "/operate-center/toB-activity/combine-activity/add",
        name: "operate-center-toB-activity-combine-activity-add",
        component: () => import("../views/operate-center/toB-activity/combine-activity/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/combine-activity/edit",
        name: "operate-center-toB-activity-combine-activity-edit",
        component: () => import("../views/operate-center/toB-activity/combine-activity/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/combine-activity/view",
        name: "operate-center-toB-activity-combine-activity-view",
        component: () => import("../views/operate-center/toB-activity/combine-activity/View.vue"),
      },
      // B端促销活动 - 买赠活动
      {
        path: "/operate-center/toB-activity/buy-gifts/list",
        name: "operate-center-toB-activity-buy-gifts-list",
        component: () => import("../views/operate-center/toB-activity/buy-gifts/List.vue"),
      },
      {
        path: "/operate-center/toB-activity/buy-gifts/add",
        name: "operate-center-toB-activity-buy-gifts-add",
        component: () => import("../views/operate-center/toB-activity/buy-gifts/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/buy-gifts/edit",
        name: "operate-center-toB-activity-buy-gifts-edit",
        component: () => import("../views/operate-center/toB-activity/buy-gifts/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/buy-gifts/view",
        name: "operate-center-toB-activity-buy-gifts-view",
        component: () => import("../views/operate-center/toB-activity/buy-gifts/View.vue"),
      },
      //c端促销活动 - 组合活动
      {
        path: "/operate-center/toC-activity/combine-activity/list",
        name: "operate-center-toC-activity-combine-activity-list",
        component: () => import("../views/operate-center/toC-activity/combine-activity/List.vue"),
      },
      {
        path: "/operate-center/toC-activity/combine-activity/add",
        name: "operate-center-toC-activity-combine-activity-add",
        component: () => import("../views/operate-center/toC-activity/combine-activity/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/combine-activity/edit",
        name: "operate-center-toC-activity-combine-activity-edit",
        component: () => import("../views/operate-center/toC-activity/combine-activity/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/combine-activity/view",
        name: "operate-center-toC-activity-combine-activity-view",
        component: () => import("../views/operate-center/toC-activity/combine-activity/View.vue"),
      },
      // c端促销活动 - 买赠活动
      {
        path: "/operate-center/toC-activity/buy-gifts/list",
        name: "operate-center-toC-activity-buy-gifts-list",
        component: () => import("../views/operate-center/toC-activity/buy-gifts/List.vue"),
      },
      {
        path: "/operate-center/toC-activity/buy-gifts/add",
        name: "operate-center-toC-activity-buy-gifts-add",
        component: () => import("../views/operate-center/toC-activity/buy-gifts/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/buy-gifts/edit",
        name: "operate-center-toC-activity-buy-gifts-edit",
        component: () => import("../views/operate-center/toC-activity/buy-gifts/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/buy-gifts/view",
        name: "operate-center-toC-activity-buy-gifts-view",
        component: () => import("../views/operate-center/toC-activity/buy-gifts/View.vue"),
      },
      {
        path: "/operate-center/toC-activity/buy-gifts/list-gift",
        name: "operate-center-toC-activity-buy-gifts-list-gift",
        component: () => import("../views/operate-center/toC-activity/buy-gifts/EditGift.vue"),
      },
      {
        path: "/operate-center/toC-activity/buy-gifts/view-gift",
        name: "operate-center-toC-activity-buy-gifts-view-gift",
        component: () => import("../views/operate-center/toC-activity/buy-gifts/ViewGift.vue"),
      },
      {
        path: "/operate-center/toC-activity/buy-gifts/order-gift",
        name: "operate-center-toC-activity-buy-gifts-order-gift",
        component: () => import("../views/operate-center/toC-activity/buy-gifts/OrderGift.vue"),
      },
      // B端促销活动 - 礼品券
      {
        path: "/operate-center/toB-activity/gift-coupon/list",
        name: "operate-center-toB-activity-gift-coupon-list",
        component: () => import("../views/operate-center/toB-activity/gift-coupon/List.vue"),
      },
      {
        path: "/operate-center/toB-activity/gift-coupon/add",
        name: "operate-center-toB-activity-gift-coupon-add",
        component: () => import("../views/operate-center/toB-activity/gift-coupon/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/gift-coupon/edit",
        name: "operate-center-toB-activity-gift-coupon-edit",
        component: () => import("../views/operate-center/toB-activity/gift-coupon/Add.vue"),
      },
      {
        path: "/operate-center/toB-activity/gift-coupon/view",
        name: "operate-center-toB-activity-gift-coupon-view",
        component: () => import("../views/operate-center/toB-activity/gift-coupon/View.vue"),
      },
      // B端促销活动 - 礼品券核销
      {
        path: "/operate-center/toB-activity/gift-coupon-verification/list",
        name: "operate-center-toB-activity-gift-coupon-verification-list",
        component: () => import("../views/operate-center/toB-activity/gift-coupon-verification/List.vue"),
      },
      {
        path: "/operate-center/toB-activity/gift-coupon-verification/view",
        name: "operate-center-toB-activity-gift-coupon-verification-view",
        component: () => import("../views/operate-center/toB-activity/gift-coupon-verification/View.vue"),
      },
      //b端促销活动 - 礼品卡
      {
        path: "/operate-center/toB-activity/gift-import/list",
        name: "operate-center-toB-activity-gift-import-list",
        component: () => import("../views/operate-center/toB-activity/gift-import/List.vue"),
      },
      //c端促销活动 -- 养牛活动
      {
        path: "/operate-center/toC-activity/feed-activity/list",
        name: "operate-center-toC-activity-feed-activity-list",
        component: () => import("../views/operate-center/toC-activity/feed-activity/List.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-activity/add",
        name: "operate-center-toC-activity-feed-activity-add",
        component: () => import("../views/operate-center/toC-activity/feed-activity/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-activity/edit",
        name: "operate-center-toC-activity-feed-activity-edit",
        component: () => import("../views/operate-center/toC-activity/feed-activity/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-activity/view",
        name: "operate-center-toC-activity-feed-activity-view",
        component: () => import("../views/operate-center/toC-activity/feed-activity/View.vue"),
      },
      //c端促销活动 -- 养牛活动的礼品管理
      {
        path: "/operate-center/toC-activity/feed-gift/list",
        name: "operate-center-toC-activity-feed-gift-list",
        component: () => import("../views/operate-center/toC-activity/feed-gift/List.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-gift/add",
        name: "operate-center-toC-activity-feed-gift-add",
        component: () => import("../views/operate-center/toC-activity/feed-gift/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-gift/edit",
        name: "operate-center-toC-activity-feed-gift-edit",
        component: () => import("../views/operate-center/toC-activity/feed-gift/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-gift/view",
        name: "operate-center-toC-activity-feed-gift-view",
        component: () => import("../views/operate-center/toC-activity/feed-gift/View.vue"),
      },
      //c端促销活动 -- 活动任务
      {
        path: "/operate-center/toC-activity/feed-task/list",
        name: "operate-center-toC-activity-feed-task-list",
        component: () => import("../views/operate-center/toC-activity/feed-task/List.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-task/edit",
        name: "operate-center-toC-activity-feed-task-edit",
        component: () => import("../views/operate-center/toC-activity/feed-task/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-task/view",
        name: "operate-center-toC-activity-feed-task-view",
        component: () => import("../views/operate-center/toC-activity/feed-task/View.vue"),
      },
      //c端促销活动 -- 扫码出库
      {
        path: "/operate-center/toC-activity/scan-delivery/list",
        name: "operate-center-toC-activity-scan-delivery-list",
        component: () => import("../views/operate-center/toC-activity/scan-delivery/List.vue"),
      },
      {
        path: "/operate-center/toC-activity/scan-delivery/add",
        name: "operate-center-toC-activity-scan-delivery-add",
        component: () => import("../views/operate-center/toC-activity/scan-delivery/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/scan-delivery/edit",
        name: "operate-center-toC-activity-scan-delivery-edit",
        component: () => import("../views/operate-center/toC-activity/scan-delivery/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/scan-delivery/view",
        name: "operate-center-toC-activity-scan-delivery-view",
        component: () => import("../views/operate-center/toC-activity/scan-delivery/View.vue"),
      },
      //c端促销活动 -- 扫码配置
      {
        path: "/operate-center/toC-activity/scan-set/list",
        name: "operate-center-toC-activity-scan-set-list",
        component: () => import("../views/operate-center/toC-activity/scan-set/List.vue"),
      },
      {
        path: "/operate-center/toC-activity/scan-set/add",
        name: "operate-center-toC-activity-scan-set-add",
        component: () => import("../views/operate-center/toC-activity/scan-set/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/scan-set/edit",
        name: "operate-center-toC-activity-scan-set-edit",
        component: () => import("../views/operate-center/toC-activity/scan-set/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/scan-set/view",
        name: "operate-center-toC-activity-scan-set-view",
        component: () => import("../views/operate-center/toC-activity/scan-set/View.vue"),
      },
      //c端促销活动 -- 养牛KV图
      {
        path: "/operate-center/toC-activity/feed-kv/list",
        name: "operate-center-toC-activity-feed-kv-list",
        component: () => import("../views/operate-center/toC-activity/feed-kv/List.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-kv/add",
        name: "operate-center-toC-activity-feed-kv-add",
        component: () => import("../views/operate-center/toC-activity/feed-kv/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-kv/edit",
        name: "operate-center-toC-activity-feed-kv-edit",
        component: () => import("../views/operate-center/toC-activity/feed-kv/Add.vue"),
      },
      //c端促销活动 -- 题库
      {
        path: "/operate-center/toC-activity/feed-qbank/list",
        name: "operate-center-toC-activity-feed-qbank-list",
        component: () => import("../views/operate-center/toC-activity/feed-qbank/List.vue"),
      },
      //c端促销活动 -- 养牛视频
      {
        path: "/operate-center/toC-activity/feed-video/list",
        name: "operate-center-toC-activity-feed-video-list",
        component: () => import("../views/operate-center/toC-activity/feed-video/List.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-video/add",
        name: "operate-center-toC-activity-feed-video-add",
        component: () => import("../views/operate-center/toC-activity/feed-video/Add.vue"),
      },
      {
        path: "/operate-center/toC-activity/feed-video/edit",
        name: "operate-center-toC-activity-feed-video-edit",
        component: () => import("../views/operate-center/toC-activity/feed-video/Add.vue"),
      },
      //c端促销活动 -- 兑换订单

      {
        path: "/operate-center/toC-activity/redeem-order/list",
        name: "operate-center-toC-activity-redeem-order-list",
        component: () => import("../views/operate-center/toC-activity/redeem-order/List.vue"),
      },
      {
        path: "/operate-center/toC-activity/redeem-order/view",
        name: "operate-center-toC-activity-redeem-order-view",
        component: () => import("../views/operate-center/toC-activity/redeem-order/View.vue"),
      },
      //c端优惠券
      {
        path: "/operate-center/customer-coupon/coupon-code/list",
        name: "operate-center-customer-coupon-coupon-code-list",
        component: () => import("../views/operate-center/customer-coupon/coupon-code/List.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon/list",
        name: "operate-center-customer-coupon-coupon-list",
        component: () => import("../views/operate-center/customer-coupon/coupon/List.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon/add",
        name: "operate-center-customer-coupon-coupon-add",
        component: () => import("../views/operate-center/customer-coupon/coupon/Add.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon/edit",
        name: "operate-center-customer-coupon-coupon-edit",
        component: () => import("../views/operate-center/customer-coupon/coupon/Add.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon/view",
        name: "operate-center-customer-coupon-coupon-view",
        component: () => import("../views/operate-center/customer-coupon/coupon/View.vue"),
      },
      {
        path: "/operate-center/customer-coupon/coupon-grant/list",
        name: "operate-center-customer-coupon-coupon-grant-list",
        component: () => import("../views/operate-center/customer-coupon/coupon-grant/List.vue"),
      },

      // B端优惠券
      {
        path: "/operate-center/shop-coupon/coupon/list",
        name: "operate-center-shop-coupon-coupon-list",
        component: () => import("../views/operate-center/shop-coupon/coupon/List.vue"),
      },
      {
        path: "/operate-center/shop-coupon/coupon/add",
        name: "operate-center-shop-coupon-coupon-add",
        component: () => import("../views/operate-center/shop-coupon/coupon/Add.vue"),
      },
      {
        path: "/operate-center/shop-coupon/coupon/edit",
        name: "operate-center-shop-coupon-coupon-edit",
        component: () => import("../views/operate-center/shop-coupon/coupon/Add.vue"),
      },
      {
        path: "/operate-center/shop-coupon/coupon/view",
        name: "operate-center-shop-coupon-coupon-view",
        component: () => import("../views/operate-center/shop-coupon/coupon/View.vue"),
      },
      {
        path: "/operate-center/shop-coupon/coupon-grant/list",
        name: "operate-center-shop-coupon-coupon-grant-list",
        component: () => import("../views/operate-center/shop-coupon/coupon-grant/List.vue"),
      },
      //货架陈列
      {
        path: "/operate-center/shop-task/display/list",
        name: "operate-center-shop-task-display-list",
        component: () => import("../views/operate-center/shop-task/display/List.vue"),
      },
      {
        path: "/operate-center/shop-task/display/add",
        name: "operate-center-shop-task-display-add",
        component: () => import("../views/operate-center/shop-task/display/Add.vue"),
      },
      {
        path: "/operate-center/shop-task/display/edit",
        name: "operate-center-shop-task-display-edit",
        component: () => import("../views/operate-center/shop-task/display/Add.vue"),
      },
      {
        path: "/operate-center/shop-task/display/view",
        name: "operate-center-shop-task-display-view",
        component: () => import("../views/operate-center/shop-task/display/View.vue"),
      },
      {
        path: "/operate-center/shop-task/display/record-view",
        name: "operate-center-shop-task-display-record-view",
        component: () => import("../views/operate-center/shop-task/display/RecordView.vue"),
      },
      // 消息广告
      {
        path: "/operate-center/message-ad/app-ad/list",
        name: "operate-center-message-ad-app-ad-list",
        component: () => import("../views/operate-center/message-ad/app-ad/List.vue"),
      },
      {
        path: "/operate-center/message-ad/app-ad/add",
        name: "operate-center-message-ad-app-ad-add",
        component: () => import("../views/operate-center/message-ad/app-ad/Add.vue"),
      },
      {
        path: "/operate-center/message-ad/app-ad/edit",
        name: "operate-center-message-ad-app-ad-edit",
        component: () => import("../views/operate-center/message-ad/app-ad/Add.vue"),
      },
      {
        path: "/operate-center/message-ad/mp-ad/list",
        name: "operate-center-message-ad-mp-ad-list",
        component: () => import("../views/operate-center/message-ad/mp-ad/List.vue"),
      },
      {
        path: "/operate-center/message-ad/mp-ad/add",
        name: "operate-center-message-ad-mp-ad-add",
        component: () => import("../views/operate-center/message-ad/mp-ad/Add.vue"),
      },
      {
        path: "/operate-center/message-ad/mp-ad/edit",
        name: "operate-center-message-ad-mp-ad-edit",
        component: () => import("../views/operate-center/message-ad/mp-ad/Add.vue"),
      },
      //消息通知
      {
        path: "/operate-center/message-ad/message-notification/list",
        name: "operate-center-message-ad-message-notification-list",
        component: () => import("../views/operate-center/message-ad/message-notification/List.vue"),
      },
      {
        path: "/operate-center/message-ad/message-notification/view",
        name: "operate-center-message-ad-message-notification-view",
        component: () => import("../views/operate-center/message-ad/message-notification/View.vue"),
      },
      {
        path: "/operate-center/message-ad/message-notification/add",
        name: "operate-center-message-ad-message-notification-add",
        component: () => import("../views/operate-center/message-ad/message-notification/Add.vue"),
      },
      {
        path: "/operate-center/message-ad/message-notification/edit",
        name: "operate-center-message-ad-message-notification-edit",
        component: () => import("../views/operate-center/message-ad/message-notification/Add.vue"),
      },
      // 内容管理
      {
        path: "/operate-center/content-manage/sell-material/list",
        name: "operate-center-content-manage-sell-material-list",
        component: () => import("../views/operate-center/content-manage/sell-material/List.vue"),
      },
      {
        path: "/operate-center/content-manage/sell-material/add",
        name: "operate-center-content-manage-sell-material-add",
        component: () => import("../views/operate-center/content-manage/sell-material/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/sell-material/edit",
        name: "operate-center-content-manage-sell-material-edit",
        component: () => import("../views/operate-center/content-manage/sell-material/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/sell-material/view",
        name: "operate-center-content-manage-sell-material-view",
        component: () => import("../views/operate-center/content-manage/sell-material/View.vue"),
      },
      {
        path: "/operate-center/content-manage/sell-material/category-view",
        name: "operate-center-content-manage-sell-material-category-view",
        component: () => import("../views/operate-center/content-manage/sell-material/CategoryView.vue"),
      },
      {
        path: "/operate-center/content-manage/article/list",
        name: "operate-center-content-manage-article-list",
        component: () => import("../views/operate-center/content-manage/article/List.vue"),
      },
      {
        path: "/operate-center/content-manage/article/add",
        name: "operate-center-content-manage-article-add",
        component: () => import("../views/operate-center/content-manage/article/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/article/edit",
        name: "operate-center-content-manage-article-edit",
        component: () => import("../views/operate-center/content-manage/article/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/article/view",
        name: "operate-center-content-manage-article-view",
        component: () => import("../views/operate-center/content-manage/article/View.vue"),
      },

      {
        path: "/operate-center/content-manage/ad-material/list",
        name: "operate-center-content-manage-ad-material-list",
        component: () => import("../views/operate-center/content-manage/ad-material/List.vue"),
      },
      {
        path: "/operate-center/content-manage/ad-material/add",
        name: "operate-center-content-manage-ad-material-add",
        component: () => import("../views/operate-center/content-manage/ad-material/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/ad-material/edit",
        name: "operate-center-content-manage-ad-material-edit",
        component: () => import("../views/operate-center/content-manage/ad-material/Add.vue"),
      },
      // 素材活动
      {
        path: "/operate-center/content-manage/material-activity/list",
        name: "operate-center-content-manage-material-activity-list",
        component: () => import("../views/operate-center/content-manage/material-activity/List.vue"),
      },
      {
        path: "/operate-center/content-manage/material-activity/add",
        name: "operate-center-content-manage-material-activity-add",
        component: () => import("../views/operate-center/content-manage/material-activity/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/material-activity/edit",
        name: "operate-center-content-manage-material-activity-edit",
        component: () => import("../views/operate-center/content-manage/material-activity/Add.vue"),
      },
      {
        path: "/operate-center/content-manage/material-activity/view",
        name: "operate-center-content-manage-material-activity-view",
        component: () => import("../views/operate-center/content-manage/material-activity/View.vue"),
      },
      {
        path: "/operate-center/content-manage/material-activity/record-view",
        name: "operate-center-content-manage-material-activity-record-view",
        component: () => import("../views/operate-center/content-manage/material-activity/RecordView.vue"),
      },
      //提现明细
      {
        path: "/operate-center/financial-manage/withdrawal-details/list",
        name: "operate-center-financial-manage-withdrawal-details-list",
        component: () => import("../views/operate-center/financial-manage/withdrawal-details/List.vue"),
      },

      {
        path: "/operate-center/financial-manage/withdrawal-details/view",
        name: "operate-center-financial-manage-withdrawal-details-view",
        component: () => import("../views/operate-center/financial-manage/withdrawal-details/View.vue"),
      },
      //对账单
      {
        path: "/operate-center/financial-manage/account-statement/list",
        name: "operate-center-financial-manage-account-statement-list",
        component: () => import("../views/operate-center/financial-manage/account-statement/List.vue"),
      },
      {
        path: "/operate-center/financial-manage/account-statement/view",
        name: "operate-center-financial-manage-account-statement-view",
        component: () => import("../views/operate-center/financial-manage/account-statement/View.vue"),
      },
      {
        path: "/operate-center/financial-manage/account-statement/details",
        name: "operate-center-financial-manage-account-statement-details",
        component: () => import("../views/operate-center/financial-manage/account-statement/Details.vue"),
      },
      //报表管理
      {
        path: "/operate-center/report-mana/material/list",
        name: "operate-center-report-mana-material-list",
        component: () => import("../views/operate-center/report-mana/material/List.vue"),
      },
      {
        path: "/operate-center/report-mana/activity-registration/list",
        name: "operate-center-report-mana-activity-registration-list",
        component: () => import("../views/operate-center/report-mana/activity-registration/List.vue"),
      },
      // 报表中心--门店协议
      {
        path: "/operate-center/report-mana/agreement/list",
        name: "operate-center-report-mana-agreement-list",
        component: () => import("../views/operate-center/report-mana/agreement/List.vue"),
      },
      //直播列表
      {
        path: "/operate-center/live-broadcast/live-manage/list",
        name: "operate-center-live-broadcast-live-manage-list",
        component: () => import("../views/operate-center/live-broadcast/live-manage/List.vue"),
      },
      {
        path: "/operate-center/live-broadcast/live-manage/view",
        name: "operate-center-live-broadcast-live-manage-view",
        component: () => import("../views/operate-center/live-broadcast/live-manage/View.vue"),
      },
      {
        path: "/operate-center/live-broadcast/live-manage/add",
        name: "operate-center-live-broadcast-live-manage-add",
        component: () => import("../views/operate-center/live-broadcast/live-manage/Add.vue"),
      },
      {
        path: "/operate-center/live-broadcast/live-manage/edit",
        name: "operate-center-live-broadcast-live-manage-edit",
        component: () => import("../views/operate-center/live-broadcast/live-manage/Add.vue"),
      },
      //主播列表
      {
        path: "/operate-center/live-broadcast/anchor/list",
        name: "operate-center-live-broadcast-anchor-list",
        component: () => import("../views/operate-center/live-broadcast/anchor/List.vue"),
      },
      //类目专区
      {
        path: "/operate-center/cate-area/area/list",
        name: "operate-center-cate-area-area-list",
        component: () => import("../views/operate-center/cate-area/area/List.vue"),
      },
      {
        path: "/operate-center/cate-area/area/add",
        name: "operate-center-cate-area-area-add",
        component: () => import("../views/operate-center/cate-area/area/Add.vue"),
      },
      {
        path: "/operate-center/cate-area/area/edit",
        name: "operate-center-cate-area-area-edit",
        component: () => import("../views/operate-center/cate-area/area/Add.vue"),
      },
      {
        path: "/operate-center/cate-area/area/view",
        name: "operate-center-cate-area-area-view",
        component: () => import("../views/operate-center/cate-area/area/View.vue"),
      },

      //扫码出库
      {
        path: "/operate-center/shop-task/scan-code/list",
        name: "operate-center-shop-task-scan-code-list",
        component: () => import("../views/operate-center/shop-task/scan-code/List.vue"),
      },
      {
        path: "/operate-center/shop-task/scan-code/view",
        name: "operate-center-shop-task-scan-code-view",
        component: () => import("../views/operate-center/shop-task/scan-code/View.vue"),
      },
      //积分任务
      {
        path: "/operate-center/integral-task/list",
        name: "operate-center-integral-task-list",
        component: () => import("../views/operate-center/integral-task/List.vue"),
      },
      {
        path: "/operate-center/integral-task/edit",
        name: "operate-center-integral-task-edit",
        component: () => import("../views/operate-center/integral-task/Add.vue"),
      },
      {
        path: "/operate-center/integral-task/view",
        name: "operate-center-integral-task-view",
        component: () => import("../views/operate-center/integral-task/View.vue"),
      },
      //积分明细
      {
        path: "/operate-center/integral-detail/list",
        name: "operate-center-integral-detail-list",
        component: () => import("../views/operate-center/integral-detail/List.vue"),
      },
      {
        path: "/operate-center/integral-detail/add",
        name: "operate-center-integral-detail-add",
        component: () => import("../views/operate-center/integral-detail/Add.vue"),
      },
      {
        path: "/operate-center/integral-detail/view",
        name: "operate-center-integral-detail-view",
        component: () => import("../views/operate-center/integral-detail/View.vue"),
      },
      // 积分商品
      {
        path: "/operate-center/integral-goods/list",
        name: "operate-center-integral-goods-list",
        component: () => import("../views/operate-center/integral-goods/List.vue"),
      },
      {
        path: "/operate-center/integral-goods/add",
        name: "operate-center-integral-goods-add",
        component: () => import("../views/operate-center/integral-goods/Add.vue"),
      },
      {
        path: "/operate-center/integral-goods/edit",
        name: "operate-center-integral-goods-edit",
        component: () => import("../views/operate-center/integral-goods/Add.vue"),
      },
      {
        path: "/operate-center/integral-goods/view",
        name: "operate-center-integral-goods-view",
        component: () => import("../views/operate-center/integral-goods/View.vue"),
      },
      {
        path: "/operate-center/integral-goods/browsing-value/edit",
        name: "operate-center-integral-goods-view-browsing-value-edit",
        component: () => import("../views/operate-center/integral-goods/browsingValue/Add.vue"),
      },
      {
        path: "/operate-center/integral-goods/browsing-value/view",
        name: "operate-center-integral-goods-view-browsing-value-view",
        component: () => import("../views/operate-center/integral-goods/browsingValue/View.vue"),
      },
      //积分订单
      {
        path: "/operate-center/integral-order/list",
        name: "operate-center-integral-order-list",
        component: () => import("../views/operate-center/integral-order/List.vue"),
      },
      {
        path: "/operate-center/integral-order/view",
        name: "operate-center-integral-order-view",
        component: () => import("../views/operate-center/integral-order/View.vue"),
      },
      //充值管理
      {
        path: "/financial-manage/charge-mana/list",
        name: "financial-manage-charge-mana-list",
        component: () => import("../views/operate-center/financial-manage/charge-mana/List.vue"),
      },
      {
        path: "/financial-manage/charge-mana/add",
        name: "financial-manage-charge-mana-add",
        component: () => import("../views/operate-center/financial-manage/charge-mana/Add.vue"),
      },

      {
        path: "/financial-manage/charge-mana/charge-log/list",
        name: "financial-manage-charge-mana-charge-log-list",
        component: () => import("../views/operate-center/financial-manage/charge-mana/charge-log/List.vue"),
      },

      {
        path: "/financial-manage/charge-mana/charge-log/view",
        name: "financial-manage-charge-mana-charge-log-view",
        component: () => import("../views/operate-center/financial-manage/charge-mana/charge-log/View.vue"),
      },

      //直播管理
      {
        path: "/operate-center/live-mana/list",
        name: "operate-center-live-mana-list",
        component: () => import("../views/operate-center/live-mana/List.vue"),
      },
    
      {
        path: "/operate-center/live-mana/view",
        name: "operate-center-live-mana-view",
        component: () => import("../views/operate-center/live-mana/View.vue"),
      },

      /*************** #end 运营中心 *********************/

      /*************** #start 维护中心 *********************/
      {
        path: "/maintain-center/distribution/order/list",
        name: "maintain-center-distribution-order-list",
        component: () => import("../views/maintain-center/distribution/order/List.vue"),
      },
      /*************** #end 维护中心 *********************/
      //充值管理
      {
        path: "/financial-manage/charge-mana/list",
        name: "financial-manage-charge-mana-list",
        component: () => import("../views/operate-center/financial-manage/charge-mana/List.vue"),
      },
      {
        path: "/financial-manage/charge-mana/add",
        name: "financial-manage-charge-mana-add",
        component: () => import("../views/operate-center/financial-manage/charge-mana/Add.vue"),
      },

      {
        path: "/financial-manage/charge-mana/charge-log/list",
        name: "financial-manage-charge-mana-charge-log-list",
        component: () => import("../views/operate-center/financial-manage/charge-mana/charge-log/List.vue"),
      },

      {
        path: "/financial-manage/charge-mana/charge-log/view",
        name: "financial-manage-charge-mana-charge-log-view",
        component: () => import("../views/operate-center/financial-manage/charge-mana/charge-log/View.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
